import React, { useMemo } from 'react'
import { useMobileRecordContext } from "../../../contexts/mobileRecordContext"
import { findOrInitEntry, mapToRecord } from "../../../utilities/mobileRecordHelper"
import EntryValue from "./entryValue"

const VerticalEntry = ({ field, map, report }) => {
  const { descendantRecords } = useMobileRecordContext()

  const parentRecord = useMemo(() => {
    if (!map) return null
    const { mappedRecord } = mapToRecord(map)(descendantRecords)
    return mappedRecord
  }, [map, descendantRecords])

  const entry = useMemo(() => report || findOrInitEntry(field, parentRecord), [field, map, parentRecord])

  return (
    <td className='border border-gray-300 p-2'>
      <EntryValue entry={entry} field={field} map={map} />
    </td>
  )
}

export default VerticalEntry
